//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AllActiveTradesModal from './AllActiveTradesModal.vue';

export default {
  components: {
    AllActiveTradesModal,
  },

  props: {
    data: { type: Object, required: true },
  },

  data() {
    return {
      allActiveTradesModal: {
        show: false,
        type: '',
        data: [],
      },
    };
  },

  methods: {
    getActiveTradesList(arr) {
      if (arr.length === 1) {
        return {
          list: arr,
        };
      }

      if (arr.length <= 20) {
        return {
          list: arr.join(', '),
        };
      }
      const maxNamesToShow = Math.ceil(arr.length / 2); // Максимальное количество имен для отображения (50%)
      return {
        list: arr.slice(0, maxNamesToShow),
        rest: arr.length - maxNamesToShow,
      };
    },

    openAllActiveTradesModal(data, type) {
      this.allActiveTradesModal.data = data;
      this.allActiveTradesModal.type = type;
      this.allActiveTradesModal.show = true;
    },
  },
};
